import React from 'react';
import { Card, Typography, Divider } from 'antd';
import './index.css';

const { Title, Paragraph } = Typography;

const About = () => {
  return (
    <div className="about-page">
      <Card>
        <Title level={2}>关于我们</Title>
        <Paragraph>
          欢迎来到我的个人博客！这是一个使用React和Ant Design构建的技术博客网站。
        </Paragraph>
        
        <Divider />
        
        <Title level={3}>技术栈</Title>
        <ul>
          <li>React 19</li>
          <li>React Router v6</li>
          <li>Ant Design</li>
          <li>LocalStorage 数据存储</li>
          <li>Markdown 渲染</li>
        </ul>
        
        <Divider />
        
        <Title level={3}>功能特点</Title>
        <ul>
          <li>响应式设计，适配各种设备</li>
          <li>文章浏览和搜索功能</li>
          <li>文章归档按年份分类</li>
          <li>支持 Markdown 格式的富文本编辑</li>
          <li>本地数据存储，无需后端服务器</li>
        </ul>
        
        <Divider />
        
        <Title level={3}>联系方式</Title>
        <Paragraph>
          如果您有任何问题或建议，可以通过以下方式联系我：
        </Paragraph>
        <ul>
          <li>邮箱: example@email.com</li>
          <li>GitHub: github.com/example</li>
        </ul>
      </Card>
    </div>
  );
};

export default About;